import account from '@/core/routes/paths/panel/account'
import home from "@/core/routes/paths/panel/home";
import announcement from "@/core/routes/paths/panel/announcement";
import financial from "@/core/routes/paths/panel/financial";
import requests from "@/core/routes/paths/panel/requests";
import services from "@/core/routes/paths/panel/services";
import support from "@/core/routes/paths/panel/support";
import referral from "@/core/routes/paths/panel/referral";
export default [
    {
        path: "/",
        redirect: '/home',
        component: () => import("@/layout/Master"),
        children: [
            ...home,
            ...support,
            ...account,
            ...announcement,
            ...services,
            ...financial,
            ...requests,
            ...referral
        ]
    }
]